import ChartNivWegrakingenSeh from "../../../../src/client/niv_acuteboekje/json/wegrakingen-seh.json";
import ChartNivSchematic from "../../../../src/client/niv_acuteboekje/interactions/chart_schematic/ChartNivSchematic";
import * as React from 'react';
export default {
  ChartNivWegrakingenSeh,
  ChartNivSchematic,
  React
};